module.exports = __webpack_public_path__ + "static/media/logoutIcon.845c0c1d.svg";